import React from "react";
import "./toggle.css";

export default function Toggle({ checked, onChange, disabled, label, activeText = "ACTIVE", inactiveText = "INACTIVE" }) {
  return (
    <div className={`custom-toggle-container ${disabled ? "disabled" : ""}`}>
      {label && <span className="custom-toggle-label">{label}</span>}
      <label className="custom-toggle-switch">
        <input
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={(e) => {
            if (!disabled && onChange) {
              onChange(e.target.checked);
            }
          }}
        />
        <span className="custom-toggle-slider"></span>
      </label>
      <span className={`custom-toggle-status-text ${checked ? "active" : "inactive"}`}>
        {checked ? activeText : inactiveText}
      </span>
    </div>
  );
}
